/* OCUDERM — la colección sin recargas y sin paginación.
 *
 * Dos cosas que el sitio hace y Shopify no hace solo:
 *
 *   1. PULSAR UN FILTRO NO RECARGA. En el sitio el catálogo vive en el
 *      navegador, así que cambiar de categoría o de marca es instantáneo. Aquí
 *      el filtrado es de servidor —y conviene que lo sea, porque la URL se
 *      comparte y Google la lee—, así que se piden solo las SECCIONES con la
 *      API de renderizado de secciones y se cambian esos trozos del DOM. La
 *      URL se actualiza con `pushState`, de modo que compartir y el botón de
 *      atrás siguen funcionando.
 *
 *   2. NO HAY PAGINACIÓN. `paginate` de Shopify tiene un tope duro de 50 por
 *      página y el catálogo son 55, así que `/collections/all` salía en dos
 *      páginas donde el sitio enseña una. Al cargar, si quedan páginas, se
 *      piden y se añaden las tarjetas a la misma rejilla. El resultado es un
 *      solo bloque continuo, que es lo que se pidió.
 *
 * LAS DOS COSAS QUE ESTE FICHERO HACE CON CUIDADO
 *
 * A) LA ENTRADA NO SE VUELVE A ANIMAR. «What we carry.» es un `[data-reveal]`:
 *    `ocu-motion.js` lo marca con `data-shown="1"` y le deja los estilos
 *    puestos. Antes se reemplazaba la sección entera —`innerHTML = …`—, así
 *    que ese párrafo se destruía y volvía a nacer sin marca: con cada cambio
 *    de marca la entrada se desvanecía y volvía a subir, que es justo lo que
 *    no debe pasar, porque ese texto no ha cambiado.
 *
 *    Ahora se cambia solo lo que cambia. El nodo vivo de la entrada se MUEVE
 *    al árbol nuevo antes de colgarlo, de modo que conserva su identidad, su
 *    `data-shown` y sus estilos. Mover y clonar no son lo mismo: clonar es lo
 *    que lo rompía.
 *
 * B) CAMBIAR DE CATEGORÍA TAMPOCO RECARGA. Antes sí: cada categoría tiene su
 *    propio hero —foto, título y nota— y su propio pie de «colección anterior
 *    / siguiente», y con una sola sección pedida no había manera de
 *    cambiarlos. Se piden las TRES a la vez —hero, rejilla y pie— con
 *    `?sections=`, que devuelve un JSON con una entrada por sección, y se
 *    cambian las tres en el mismo fotograma. El título de la pestaña viaja en
 *    `data-ocu-title` sobre el hero, porque la API devuelve secciones y no
 *    `<head>`.
 *
 * POR QUÉ NO SE ROMPE SIN JAVASCRIPT
 *
 * Las pastillas son enlaces de verdad y la paginación se pinta en el HTML. Si
 * esto no carga, la página sigue filtrando y paginando como siempre — más
 * lenta, pero entera. Por eso los enlaces no se tocan hasta que el script está
 * vivo, y la paginación solo se oculta desde aquí.
 */

(function () {
  var seccion = document.querySelector('[data-ocu-colgrid]');
  if (!seccion) return;

  var idRejilla = seccion.getAttribute('data-section-id');
  if (!idRejilla) return;

  /* Los hermanos se localizan por la clase que les pone su propio `schema`
     —`"class"`—, no por un marcador dentro: el pie de colección se pinta
     dentro de un `{% if %}` y podría no estar, mientras que el envoltorio de
     la sección lo pone Shopify siempre. De ahí se saca el id, que es lo que
     pide la API. */
  function hermano(clase) {
    var el = document.querySelector('.' + clase);
    if (!el || !el.id) return null;
    el.ocuId = el.id.replace(/^shopify-section-/, '');
    return el;
  }

  var elHero = hermano('ocu-collection-hero-section');
  var elPie = hermano('ocu-colfoot-wrapper');

  /* La cortina de `ocu-motion.js` mira esta marca para saber que las pastillas
     las atiende este script. Si este fichero no llega a cargar, la marca no
     está y la cortina vuelve a cubrir el cambio de categoría, que entonces sí
     es una navegación de verdad. */
  document.documentElement.setAttribute('data-ocu-colajax', '');

  /* ── Pedir secciones ──────────────────────────────────────────────────── */

  function pedir(url, ids) {
    var u = new URL(url, location.origin);
    u.searchParams.set('sections', ids.join(','));
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('respuesta ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var docs = {};
        for (var i = 0; i < ids.length; i++) {
          if (typeof json[ids[i]] !== 'string') throw new Error('falta ' + ids[i]);
          docs[ids[i]] = new DOMParser().parseFromString(json[ids[i]], 'text/html');
        }
        return docs;
      });
  }

  /* ── Las páginas que faltan ───────────────────────────────────────────────
     Se piden EN SERIE, no en paralelo: son dos como máximo y pedirlas a la vez
     no ahorra nada perceptible, mientras que en serie se puede cortar en
     cuanto una falla sin dejar huecos en medio de la rejilla. */

  function completarRejilla(raiz) {
    var pag = raiz.querySelector('[data-ocu-pages]');
    if (!pag) return;

    var rejilla = raiz.querySelector('.ocu-colgrid__grid');
    if (!rejilla) return;

    var total = parseInt(pag.getAttribute('data-pages'), 10) || 1;
    var actual = parseInt(pag.getAttribute('data-current'), 10) || 1;
    if (total <= 1) return;

    /* Se oculta ya: a partir de aquí la rejilla se completa sola y una
       paginación a medio usar confundiría más que ayudar. */
    pag.hidden = true;

    var base = new URL(location.href);
    var siguiente = actual;

    function siguientePagina() {
      siguiente += 1;
      if (siguiente > total) return;
      base.searchParams.set('page', String(siguiente));
      pedir(base.toString(), [idRejilla])
        .then(function (docs) {
          var nuevas = docs[idRejilla].querySelectorAll('.ocu-pcard');
          for (var i = 0; i < nuevas.length; i++) {
            rejilla.appendChild(document.importNode(nuevas[i], true));
          }
          avisarMovimiento();
          siguientePagina();
        })
        .catch(function () {
          /* Si una página falla se deja la paginación a la vista para que se
             pueda llegar al resto a mano. */
          pag.hidden = false;
        });
    }

    siguientePagina();
  }

  /* ── La pastilla puesta, a la vista ────────────────────────────────────
     En el teléfono cada eje es UNA fila que se arrastra de lado, así que la
     pastilla activa puede estar fuera de la pantalla: se entra en «Serums» y
     la fila enseña «Everything · Cleansers · SPF». Esto la trae al principio
     de la fila, sin mover la página.

     `scrollIntoView` no sirve aquí: arrastraría también el documento para
     centrar el elemento verticalmente. Se mueve la fila a mano. */
  function asomarActivas(raiz) {
    var filas = raiz.querySelectorAll('.ocu-filters__pills');
    for (var i = 0; i < filas.length; i++) {
      var fila = filas[i];
      if (fila.scrollWidth <= fila.clientWidth + 1) continue;
      var puesta = fila.querySelector('.ocu-chip--on');
      if (!puesta) continue;
      var dentro = puesta.offsetLeft - fila.offsetLeft;
      var margen = 24;
      if (dentro < fila.scrollLeft || dentro + puesta.offsetWidth > fila.scrollLeft + fila.clientWidth) {
        fila.scrollLeft = Math.max(0, dentro - margen);
      }
    }
  }

  /* ── La barra de filtro del teléfono ───────────────────────────────────
     La barra dice qué hay puesto y cuántos productos quedan, y abre las
     pastillas en un panel. El texto no se repite en Liquid: se lee de las
     pastillas activas, así que después de cada cambio sin recargar sigue
     diciendo la verdad sin tocar nada más. */

  function pintarBarra(raiz) {
    var barra = raiz.querySelector('[data-filterbar]');
    if (!barra) return;

    var estado = barra.querySelector('[data-filterbar-state]');
    if (estado) {
      var puestas = raiz.querySelectorAll('[data-filters] .ocu-chip--on');
      var nombres = [];
      for (var i = 0; i < puestas.length; i++) {
        /* Se clona para quitarle el contador de al lado sin tocar la pastilla
           de verdad, que sigue en el panel con su número. */
        var copia = puestas[i].cloneNode(true);
        var meta = copia.querySelector('.ocu-chip__meta');
        if (meta && meta.parentNode) meta.parentNode.removeChild(meta);
        var t = copia.textContent.replace(/\s+/g, ' ').trim();
        if (t) nombres.push(t);
      }
      estado.textContent = nombres.join(' \u00b7 ');
    }

    var cuenta = barra.querySelector('[data-filterbar-count]');
    var linea = raiz.querySelector('.ocu-filters__count');
    if (cuenta && linea) {
      /* «16 products · ALASTIN» → «16 products». La marca ya la dice el estado
         del botón, y repetirla en la misma línea sobra. */
      cuenta.textContent = linea.textContent.split('\u00b7')[0].replace(/\s+/g, ' ').trim();
    }
  }

  var scrollPanel = 0;

  function panel() {
    return seccion.querySelector('[data-filters]');
  }

  function velo() {
    return seccion.querySelector('.ocu-filters__scrim');
  }

  function abrirPanel() {
    var p = panel();
    var v = velo();
    if (!p || p.classList.contains('is-open')) return;

    if (v) {
      v.hidden = false;
      /* Un fotograma entre quitar `hidden` y poner la clase: sin él el
         navegador no tiene estado de partida y el velo aparece de golpe. */
      requestAnimationFrame(function () {
        v.classList.add('is-open');
      });
    }
    p.classList.add('is-open');

    var b = seccion.querySelector('[data-filters-open]');
    if (b) b.setAttribute('aria-expanded', 'true');

    scrollPanel = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollPanel + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';

    document.addEventListener('keydown', alPulsarEnPanel, true);
  }

  function cerrarPanel() {
    var p = panel();
    var v = velo();
    if (!p || !p.classList.contains('is-open')) return;

    p.classList.remove('is-open');
    if (v) {
      v.classList.remove('is-open');
      setTimeout(function () {
        if (!v.classList.contains('is-open')) v.hidden = true;
      }, 300);
    }

    var b = seccion.querySelector('[data-filters-open]');
    if (b) b.setAttribute('aria-expanded', 'false');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollPanel);

    document.removeEventListener('keydown', alPulsarEnPanel, true);
  }

  function alPulsarEnPanel(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      cerrarPanel();
    }
  }

  /* Delegado en el documento: la barra y el panel se vuelven a pintar con cada
     cambio de filtro, así que un oyente por botón moriría con ellos. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-filters-open]')) {
      e.preventDefault();
      abrirPanel();
      return;
    }
    if (e.target.closest('[data-filters-close]')) {
      e.preventDefault();
      cerrarPanel();
    }
  });

  /* La capa de movimiento prepara y dispara los `[data-reveal]` al entrar en
     pantalla. Las tarjetas que llegan después no pasaron por ese reparto, así
     que se le avisa para que las repase. */
  function avisarMovimiento() {
    window.dispatchEvent(new CustomEvent('ocu:dom'));
  }

  /* ── El cambio ────────────────────────────────────────────────────────── */

  var pidiendo = false;
  var rutaPintada = location.pathname;

  /* Cambia la rejilla conservando el nodo vivo de la entrada.

     Se trabaja sobre `.ocu-colgrid__wrap` entero y no rule por rule: dentro
     cambian las pastillas, la línea de cuenta, la rejilla —o el mensaje de
     «no hay nada»— y la paginación, y cuáles de esos existen depende del
     filtro. Reemplazar el envoltorio cubre todos los casos sin una lista. */
  function cambiarRejilla(doc) {
    var nueva = doc.querySelector('[data-ocu-colgrid]');
    if (!nueva) throw new Error('sin rejilla');

    var wrapViejo = seccion.querySelector('.ocu-colgrid__wrap');
    var wrapNuevo = nueva.querySelector('.ocu-colgrid__wrap');
    if (!wrapViejo || !wrapNuevo) {
      seccion.innerHTML = nueva.innerHTML;
      return;
    }

    /* Primero al documento vivo —`importNode`—, porque el `wrapNuevo` que da
       el parser pertenece a otro documento. */
    wrapNuevo = document.importNode(wrapNuevo, true);

    var introViva = wrapViejo.querySelector('.ocu-colgrid__intro');
    var introClon = wrapNuevo.querySelector('.ocu-colgrid__intro');
    if (introViva && introClon && introClon.parentNode) {
      /* Aquí está el detalle: se MUEVE el nodo que ya estaba, con su
         `data-shown` y sus estilos puestos, en lugar de dejar el recién
         nacido. Por eso el texto no se reanima. */
      introClon.parentNode.replaceChild(introViva, introClon);
    }

    wrapViejo.parentNode.replaceChild(wrapNuevo, wrapViejo);
  }

  function cambiarHermano(el, doc) {
    if (!el) return;
    var nuevo = doc.querySelector('.shopify-section, [id^="shopify-section-"]');
    /* Con `?sections=` la respuesta ya viene envuelta; si algún día no lo
       estuviera, el `body` del documento es el contenido. */
    el.innerHTML = nuevo ? nuevo.innerHTML : doc.body.innerHTML;
  }

  function cambiarA(url, empujar) {
    if (pidiendo) return;

    var destino = new URL(url, location.origin);
    var cambiaCategoria = destino.pathname !== rutaPintada;

    var ids = [idRejilla];
    if (cambiaCategoria) {
      if (elHero) ids.push(elHero.ocuId);
      if (elPie) ids.push(elPie.ocuId);
    }

    pidiendo = true;
    seccion.setAttribute('aria-busy', 'true');

    /* Dónde estaba la rejilla antes del cambio. Al cambiar de categoría el
       hero se repinta con otra nota, que puede ocupar una línea más o una
       menos, y sin esto la rejilla da un salto bajo el cursor. */
    var antes = seccion.getBoundingClientRect().top;

    pedir(destino.toString(), ids)
      .then(function (docs) {
        cambiarRejilla(docs[idRejilla]);

        if (cambiaCategoria) {
          if (elHero && docs[elHero.ocuId]) {
            cambiarHermano(elHero, docs[elHero.ocuId]);
            var marca = elHero.querySelector('[data-ocu-title]');
            var titulo = marca && marca.getAttribute('data-ocu-title');
            if (titulo) document.title = titulo;
          }
          if (elPie && docs[elPie.ocuId]) cambiarHermano(elPie, docs[elPie.ocuId]);
        }

        if (empujar) history.pushState({ ocu: true }, '', destino.toString());
        rutaPintada = destino.pathname;

        /* Solo se compensa si la rejilla ya estaba por encima del borde
           superior, es decir, si se está mirando el catálogo. Arriba del todo
           no se toca el scroll: ahí mover la página sería el salto. */
        if (antes < 0) {
          var despues = seccion.getBoundingClientRect().top;
          if (Math.abs(despues - antes) > 1) window.scrollBy(0, despues - antes);
        }

        asomarActivas(seccion);
        pintarBarra(seccion);
        avisarMovimiento();
        completarRejilla(seccion);
      })
      .catch(function () {
        /* Cualquier fallo: se navega de verdad. Vale más una recarga que una
           rejilla que no responde. */
        location.href = destino.toString();
      })
      .then(function () {
        pidiendo = false;
        seccion.removeAttribute('aria-busy');
      });
  }

  /* Un solo oyente delegado en la sección, no uno por pastilla: las pastillas
     se reemplazan en cada cambio y los oyentes por pastilla morirían con
     ellas. */
  seccion.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target.closest ? e.target.closest('[data-filters] a') : null;
    if (!a) return;

    var href = a.getAttribute('href');
    if (!href) return;

    var destino = new URL(href, location.origin);
    /* Fuera de la tienda —si alguna pastilla llevara a otro sitio— que navegue
       el navegador. */
    if (destino.origin !== location.origin) return;
    if (destino.pathname.indexOf('/collections/') !== 0) return;

    e.preventDefault();
    /* Se cierra antes de pedir: el panel tapa la rejilla, y dejarlo abierto
       mientras llega la respuesta hace pensar que no pasó nada. */
    cerrarPanel();
    cambiarA(destino.toString(), true);
  });

  window.addEventListener('popstate', function () {
    cambiarA(location.href, false);
  });

  asomarActivas(seccion);
  pintarBarra(seccion);
  completarRejilla(seccion);
})();
